import { useMutation } from '@tanstack/react-query';

export const useCopyToClipboard = (text: string) =>
    useMutation<void, Error, void>({
        mutationKey: ['copy-to-clipboard', text],
        mutationFn: async () => {
            await navigator.clipboard.writeText(text);
        },
    });
